import React from "react";

const Container = ({ children }) => {
  return (
    <div className=" px-6  sm:px-8 mx-auto max-w-[1600px] my-10 w-full">
      {children}
    </div>
  );
};

export default Container;
